import { useEffect, useState } from "react";
import { ArrowRight, Loader2, Sparkles } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export const CosaStiamoFacendo = () => {
  const [items, setItems] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const res = await fetch(`${API}/api/activities`);
        if (!res.ok) throw new Error("Errore caricamento attività.");
        const data = await res.json();
        if (alive) setItems(data);
      } catch (e) {
        if (alive) setError(e.message);
      }
    })();
    return () => {
      alive = false;
    };
  }, []);

  return (
    <section
      id="cosa-facciamo"
      data-testid="activities-section"
      className="relative py-20 sm:py-28 bg-white border-t border-[#E5E1D8] overflow-hidden"
    >
      <div className="pointer-events-none absolute -top-32 right-0 w-[500px] h-[500px] rounded-full bg-[#2E4F3B]/[0.05] blur-3xl" />
      <div className="pointer-events-none absolute -bottom-32 left-0 w-[500px] h-[500px] rounded-full bg-[#C15C3D]/[0.05] blur-3xl" />

      <div className="relative max-w-6xl mx-auto px-6 sm:px-8 lg:px-12">
        {/* Header */}
        <div className="max-w-3xl mb-14 sm:mb-16">
          <div className="inline-flex items-center gap-2 rounded-full bg-[#2E4F3B]/10 border border-[#2E4F3B]/20 px-4 py-2 mb-5">
            <Sparkles className="w-3.5 h-3.5 text-[#2E4F3B]" />
            <span className="text-[10px] sm:text-xs font-bold uppercase tracking-[0.22em] text-[#2E4F3B]">
              Attualmente in corso
            </span>
          </div>
          <h2
            data-testid="activities-title"
            className="font-display text-3xl sm:text-4xl lg:text-5xl font-black text-[#1A1A1A] leading-[1.05] tracking-tight"
          >
            Cosa stiamo
            <span className="italic font-light text-[#2E4F3B]"> facendo.</span>
          </h2>
          <p className="mt-5 text-lg sm:text-xl text-[#5C5C5C] leading-relaxed">
            Ogni giorno lavoriamo per aiutare il territorio, supportare i
            cittadini e costruire progetti concreti per il futuro di Asciano e
            del Monte Faeta.
          </p>
        </div>

        {/* Cards grid */}
        {items === null && !error && (
          <div className="flex items-center justify-center py-16 text-[#5C5C5C]">
            <Loader2 className="w-5 h-5 animate-spin mr-2" />
            Caricamento attività…
          </div>
        )}

        {error && (
          <div className="text-center py-8 text-[#C15C3D]">{error}</div>
        )}

        {items && items.length > 0 && (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6">
            {items.map((a, i) => (
              <article
                key={a.id}
                data-testid={`activity-card-${i}`}
                className="group flex flex-col bg-white border-2 border-[#E5E1D8] hover:border-[#2E4F3B] rounded-2xl p-6 sm:p-7 transition-all hover:-translate-y-1 hover:shadow-[0_15px_40px_rgba(0,0,0,0.08)]"
              >
                <div className="text-4xl sm:text-5xl mb-4 leading-none select-none">
                  {a.emoji}
                </div>
                <h3 className="font-display text-lg sm:text-xl font-black text-[#1A1A1A] leading-tight mb-3">
                  {a.title}
                </h3>
                <p className="text-sm sm:text-base text-[#5C5C5C] leading-relaxed flex-1">
                  {a.description}
                </p>

                {a.cta_label && a.cta_url && (
                  <a
                    href={a.cta_url}
                    target={a.cta_url.startsWith("http") ? "_blank" : undefined}
                    rel={a.cta_url.startsWith("http") ? "noopener noreferrer" : undefined}
                    data-testid={`activity-cta-${i}`}
                    className="mt-5 inline-flex items-center gap-2 self-start rounded-full bg-[#2E4F3B] hover:bg-[#1f3828] text-white font-semibold text-sm px-5 py-2.5 transition-colors group/btn"
                  >
                    {a.cta_label}
                    <ArrowRight className="w-4 h-4 transition-transform group-hover/btn:translate-x-1" />
                  </a>
                )}
              </article>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};
